import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';

var TABLE_SIZES = {
  LARGE: 'large',
  REGULAR: 'regular',
  SMALL: 'small'
};
var TEXT_ALIGN = {
  CENTER: 'center',
  END: 'end',
  INHERIT: 'inherit',
  INITIAL: 'initial',
  JUSTIFY: 'justify',
  LEFT: 'left',
  REVERT: 'revert',
  RIGHT: 'right',
  START: 'start',
  UNSET: 'unset'
};
var SORT_ORDER = {
  ASCENDING: 'asc',
  DEFAULT: 'default',
  DESCENDING: 'desc'
};
var SORT_ICONS = _defineProperty(_defineProperty(_defineProperty({}, SORT_ORDER.ASCENDING, 'SortAscending'), SORT_ORDER.DEFAULT, 'SortNone'), SORT_ORDER.DESCENDING, 'SortDescending');
var HEADER_CELL_HEIGHT = _defineProperty(_defineProperty(_defineProperty({}, TABLE_SIZES.SMALL, 2), TABLE_SIZES.REGULAR, 2.5), TABLE_SIZES.LARGE, 3);
var DATA_CELL_HEIGHT = _defineProperty(_defineProperty(_defineProperty({}, TABLE_SIZES.SMALL, 1.5), TABLE_SIZES.REGULAR, 2), TABLE_SIZES.LARGE, 2.5);

export { DATA_CELL_HEIGHT, HEADER_CELL_HEIGHT, SORT_ICONS, SORT_ORDER, TABLE_SIZES, TEXT_ALIGN };
//# sourceMappingURL=Table.constants.js.map
